import html2pdf from 'html2pdf.js';

const PDF_PAGE_HEIGHT = 860;
const PDF_PAGE_WIDTH_ADJUSTMENT = 240;
const PDF_PAGE_ORIENTATION = 'portrait';
const PDF_PAGE_RENDERING_UNIT = 'pt';
const HTML_2_CANVAS_SCALE = 2;
const HTML_2_CANVAS_IMAGE_TYPE = 'png';
const HTML_2_CANVAS_IMAGE_QUALITY = 0.98;
const PDF_PAGE_MARGIN_TOP_RIGHT_BOTTOM_LEFT = [50, 0, 50, 0];

export const onPDFDownloadHandler = (a4ContainerRef, downloadFileName) => {
    const htmlToPDFConfigurationOptions = {
        margin: PDF_PAGE_MARGIN_TOP_RIGHT_BOTTOM_LEFT,
        filename: downloadFileName,
        image: {
            type: HTML_2_CANVAS_IMAGE_TYPE,
            quality: HTML_2_CANVAS_IMAGE_QUALITY
        },
        pagebreak: { mode: ['css'] },
        html2canvas: { scale: HTML_2_CANVAS_SCALE },
        jsPDF: {
            unit: PDF_PAGE_RENDERING_UNIT,
            format: [
                a4ContainerRef.current.offsetWidth - PDF_PAGE_WIDTH_ADJUSTMENT,
                PDF_PAGE_HEIGHT
            ],
            orientation: PDF_PAGE_ORIENTATION
        }
    };

    html2pdf()
        .set(htmlToPDFConfigurationOptions)
        .from(a4ContainerRef.current)
        .toPdf()
        .save(downloadFileName)
        .output('bloburl')
        .then(function (pdfas) {
            window.open(pdfas);
        });
};
